import React, { createContext, useContext, useState } from 'react';

type LanguageContextType = {
    language: string,
    setLanguage: (value: string) => void;
  }

const LanguageContext = createContext<LanguageContextType | undefined>(
    undefined
);

type PropTypes = {
    children: React.ReactNode
};
export const LanguageProvider = ({children}: PropTypes) => {

    const [language, setLanguage] = useState('en')

    return (
        <LanguageContext.Provider value={{language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
      )
}

export function useLanguage() {
    const context = useContext(LanguageContext);
  
    if (!context) {
      throw new Error('"useSession" must be used within IssuesContext')
    }
  
    return context;
  }